import { colors } from "@material-ui/core";
import React from "react";

export function AlertIcon(props: React.PropsWithChildren<{ alert?: boolean }>) {
	return <div style={{ color: props.alert ? colors.red[500] : undefined, paddingTop: 4, paddingLeft: 10 }}>{props.children}</div>;
}